import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { Experiment } from '@ms/yammer-data/dist/state/types';
import { configureTelemetry } from '@ms/yammer-data/dist/telemetry';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

import config from '../../config';
import { persistConfig } from '../../persistedState';

export const configure = async () => {
  const isMsal = (await getPersistedExperimentTreatment(persistConfig.key, Experiment.EmbedMsal)) as boolean;

  configureTelemetry({
    config,
    hostingConfig: readHostingConfiguration(),
    skipNextCleanup: true,
    registerUnhandledEventsListener: true,
    isMsal,
  });
};
